import { endpoint } from '../../shared/endpoints.model';
import { Component, OnInit } from "@angular/core";
import { LoggerService } from "src/shared/logger/logger.service";
import { Levels } from 'src/shared/logger/levels.enum';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmationComponent } from "src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component";
import { AddNoteComponent } from './dialog-add-note/addNote.dialog.component';
import { RollbackComponent } from './dialog-rollback/rollback.component';

@Component({
  selector: 'system-state-provisioning-component',
  templateUrl: './system-state-provisioing.component.html',
  styleUrls: ['./system-state-provisioing.component.css']
})

export class SystemStateProvisioningComponent implements OnInit {

  endpoint_data: endpoint;
  adminAuthorization: boolean;
  provisionProcessFlag: boolean = false;
  systemMarketLocationData: { id: Number, market_name: string, location_name: string };
  Math = Math;
  currentDate: any = new Date();
  lastDownDate: any = new Date();

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.systemService.endpointDateToBeTransmitted.subscribe(data => {
      this.endpoint_data = data;
      this.currentDate = new Date();
      this.lastDownDate = Date.parse(this.endpoint_data.last_down_time)
      if (this.endpoint_data && this.endpoint_data.market_location_id) {
        this.systemService.getSystemMarketLocation(this.endpoint_data?.system_ip).subscribe(data => {
          if (data["message"]?.id) {
            this.systemMarketLocationData = data["message"];
          }
        }, err => {
          this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
        })
      }
    });
    this.adminAuthorization = this.systemService.adminAuthorization

  }

  openDialogUnprovision(): void {
    if (this.provisionProcessFlag) return;

    let systemToBeDeleted = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Unprovision and delete system", message: `Are you sure you want to unprovision system with name = ${systemToBeDeleted.name} and ip = ${systemToBeDeleted.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.unProvisionSystem(systemToBeDeleted);
      }
    });
  }

  openDialogProvision(): void {
    if (this.provisionProcessFlag) return;

    let systemToBeProvisioned = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Provision system by VMS", message: `VMS will send a provision request to system with name = ${systemToBeProvisioned.name} and ip = ${systemToBeProvisioned.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.provisionSystem(systemToBeProvisioned);
      }
    });
  }

  openAddNoteDialog(): void {
    const dialogRef = this.dialog.open(AddNoteComponent, {
      width: '450px',
      data: this.endpoint_data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        result.enable_phonebook = result.enable_phonebook == '1' ? "On" : "Off"
        result.enable_sip = result.enable_sip == '1' ? "On" : "Off"
        result.enable_h323 = result.enable_h323 == '1' ? "On" : "Off"
        this.systemService.endpointDateToBeTransmitted.next(result);
      }
    });
  }

  openRollbackDialog(): void {
    const dialogRef = this.dialog.open(RollbackComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      data: { system_ip: this.endpoint_data.system_ip, system_name: this.endpoint_data.system_name },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.systemService.endpointDateToBeTransmitted.next(result);
      }
    });
  }

  openRemoveBackupDialog(): void {
    let systemBackupsToBeDeleted = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Remove All Configuration and Status Backups", message: `Are you sure you want to remove all backups for system with name = ${systemBackupsToBeDeleted.name} and ip = ${systemBackupsToBeDeleted.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sendRemoveBackupsRequest(systemBackupsToBeDeleted);
      }
    });
  }

  openBackupDialog(): void {
    let systemToBeBackedUp = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Backup Configuration and Status Files", message: `Are you sure you want to take backup for system with name = ${systemToBeBackedUp.name} and ip = ${systemToBeBackedUp.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sendBackupRequest(systemToBeBackedUp);
      }
    });
  }

  openDialogMonitor(): void {
    if (this.systemMarketLocationData?.market_name == 'Not Supported') {
      return;
    }
    let monitorFlag: Number = this.endpoint_data.is_monitored == 1 ? 0 : 1;
    let systemToBeProvisioned = { id: this.endpoint_data.id, name: this.endpoint_data.system_name, ip: this.endpoint_data.system_ip }
    let title = this.endpoint_data.is_monitored == 1 ? "Stop monitoring unit" : "Start monitoring unit";
    let message = this.endpoint_data.is_monitored == 1 ? "VMS will send a request to stop monitor" : "VMS will send a request to start monitor";

    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: title, message: `${message}  and health checking system with name = ${systemToBeProvisioned.name} and ip = ${systemToBeProvisioned.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sendMonitorRequest(monitorFlag, systemToBeProvisioned);
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  unProvisionSystem(systemToBeDeleted) {
    if (this.provisionProcessFlag) return;
    this.provisionProcessFlag = true;
    this.systemService.unprovisionSystemWithNoDelete(systemToBeDeleted.ip).subscribe(res => {
      this.endpoint_data.is_provisioned = 0;
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data);
      this.provisionProcessFlag = false;
      this.loggerService.log("SystemStateProvisioningComponent", `System was unprovisioned with id = ${systemToBeDeleted.id} , name = ${systemToBeDeleted.name} and ip = ${systemToBeDeleted.ip}.`, Levels.warning)
      this.openSnackBar('System unprovision is done', "Success");
    }, err => {
      this.provisionProcessFlag = false;
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeDeleted.id} could not be unprovisioned`, Levels.error)
      this.loggerService.log("SystemStateProvisioningComponent", err.message, Levels.error)
      this.openSnackBar('Connection error occurred while unprovisioning system', "Error");
    })
  }
  provisionSystem(systemToBeProvisioned) {
    if (this.provisionProcessFlag) return;
    this.provisionProcessFlag = true;
    this.systemService.provisionSystem(systemToBeProvisioned.ip).subscribe(res => {
      this.provisionProcessFlag = false;
      this.endpoint_data.is_provisioned = 1;
      this.endpoint_data.enable_phonebook = this.endpoint_data.enable_phonebook == '1' ? "On" : "Off"
      this.endpoint_data.enable_sip = this.endpoint_data.enable_sip == '1' ? "On" : "Off"
      this.endpoint_data.enable_h323 = this.endpoint_data.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data);
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeProvisioned.id} , name = ${systemToBeProvisioned.name} and ip = ${systemToBeProvisioned.ip} is now provisioned`, Levels.warning)
      this.openSnackBar('System provision is done', "Success");
    }, err => {
      this.provisionProcessFlag = false;
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeProvisioned.id} could not be provisioned`, Levels.error)
      this.loggerService.log("SystemStateProvisioningComponent", err.message, Levels.error)
      this.openSnackBar('Connection error occurred while sending a provision request to system', "Error");
    })
  }

  sendMonitorRequest(monitorFlag, systemToBeProvisioned) {
    this.systemService.monitorOrUnmonitorSystem(monitorFlag, systemToBeProvisioned.ip).subscribe(res => {
      this.endpoint_data.is_monitored = monitorFlag ? 1 : 0;
      this.endpoint_data.enable_phonebook = this.endpoint_data.enable_phonebook == '1' ? "On" : "Off"
      this.endpoint_data.enable_sip = this.endpoint_data.enable_sip == '1' ? "On" : "Off"
      this.endpoint_data.enable_h323 = this.endpoint_data.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data);
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeProvisioned.id} , name = ${systemToBeProvisioned.name} and ip = ${systemToBeProvisioned.ip} is now monitored/unmonitored and its monitoring state is ${this.endpoint_data.is_monitored}`, Levels.warning)
      this.openSnackBar('System monitoring is done', "Success");
    }, err => {
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeProvisioned.id} could not be monitored/unmonitored and its monitoring state is ${this.endpoint_data.is_monitored}`, Levels.error)
      this.loggerService.log("SystemStateProvisioningComponent", err.message, Levels.error)
      this.openSnackBar('Connection error occurred while sending a monitor request to system', "Error");
    })
  }

  sendRemoveBackupsRequest(systemToBeDeleted) {
    this.systemService.removeAllBackups(systemToBeDeleted.ip).subscribe(res => {
      this.loggerService.log("SystemStateProvisioningComponent", `System backups were deleted  for ip = ${systemToBeDeleted.ip} , name = ${systemToBeDeleted.name}.`, Levels.warning)
      this.openSnackBar('Backups removal is done', "Success");
    }, err => {
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeDeleted.id} could not delete backup files`, Levels.error)
      this.openSnackBar('Connection error occurred while removing backups for system', "Error");
    })
  }

  sendBackupRequest(systemToBeBackedUp) {
    this.systemService.takeBackup(systemToBeBackedUp.ip).subscribe(res => {
      this.openSnackBar('System backup is completed', "Success");
    }, err => {
      this.loggerService.log("SystemStateProvisioningComponent", `System with id = ${systemToBeBackedUp.id} error while backing up files`, Levels.error)
      this.openSnackBar('Connection error occurred while taking backup for system files', "Error");
    })
  }

  returnElementColor(element: endpoint) {
    if (element.status == "No HTTPS response") return "red";
    else if (element.status == "Idle" || element.status == "In a call") return "green";
    else return "blue";
  }

  goToLink(endpoint) {
    let url = "https://" + endpoint.system_ip + "/"
    window.open(url, "_blank");
  }

}
